/**
 * @description
 *	List of HTTP/HTTPS methods (not verbs, because OPTIONS is a noun, for
 *	example).
 */
enum HTTPMethod {
	CONNECT = "CONNECT",
	DELETE = "DELETE",
	GET = "GET",
	HEAD = "HEAD",
	OPTIONS = "OPTION",
	PATCH = "PATCH",
	POST = "POST",
	PUT = "PUT",
	TRACE = "TRACE"
}

export default HTTPMethod
